<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.3798 13.9943L29.4102 14.1841L29.5989 14.2081C33.3101 14.6792 36 17.694 36 21.5675C36 23.622 35.2531 25.5534 33.8998 27.0083L33.8989 27.0092C33.0427 27.9387 31.9585 28.6244 30.7572 29.0007L31.4634 26.882C33.2004 25.8373 34.3407 23.8648 34.3407 21.5675C34.3407 18.2632 31.9361 15.8326 28.6437 15.7981L27.8703 15.7901L27.8243 15.0205C27.7027 13.0244 26.8238 11.1504 25.3679 9.78162C23.9121 8.41289 21.9892 7.6522 19.9922 7.65416C17.9953 7.65613 16.0739 8.4206 14.6208 9.7922C13.1676 11.1639 12.2923 13.0393 12.1747 15.0356L12.1326 15.7628L11.4039 15.8132C8.20132 16.0346 5.65926 18.5443 5.65926 21.5675C5.65926 22.968 6.1951 24.2879 7.06111 25.3378L6.46252 27.1338C6.42853 27.1018 6.39481 27.0694 6.36134 27.0367C4.83546 25.5443 4.00003 23.602 4 21.5676C4.00077 20.6102 4.19377 19.6626 4.56761 18.7811C4.94147 17.8995 5.48863 17.1018 6.17678 16.4353C7.33511 15.3057 8.80849 14.5514 10.403 14.2726L10.5827 14.2412L10.6107 14.0589C10.9536 11.8218 12.0843 9.78028 13.7997 8.30247C15.5152 6.8246 17.7026 6.00785 19.9676 6.00006C22.2326 5.99226 24.4255 6.79394 26.1512 8.25997C27.8767 9.72595 29.0214 11.7597 29.3798 13.9943Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.889 23.2117L9.33333 34L7.86173 33.974L11.3912 23.2641L12.889 23.2117Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9003 23.2117L13.3446 34L11.873 33.974L15.4025 23.2641L16.9003 23.2117Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.9118 23.2117L17.3562 34L15.8845 33.974L19.414 23.2641L20.9118 23.2117Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.9232 23.2117L21.3676 34L19.896 33.974L23.4254 23.2641L24.9232 23.2117Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9346 23.2117L25.379 34L23.9074 33.974L27.4369 23.2641L28.9346 23.2117Z"
      class="fill-current"
    />
  </svg>
</template>
